interface RGB {
    r : number
    g : number
    b : number
}
export function contrastColor(r : number, g : number, b: number) {
    let brightness = Math.round(((r * 299) + (g * 587) + (b * 114)) / 1000);
    return (brightness > 150) ? '#333333' : '#ffffff';
}

export function hexToRGB(hex: string) : RGB {
    let m = hex.match(/^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i);
    if (!m) {
        return {r: 0, g: 0, b: 0}
    }
    return {
        r: parseInt(m[1], 16),
        g: parseInt(m[2], 16),
        b: parseInt(m[3], 16)
    };
}

export function invertRGB(r: number, g: number, b: number) {
    r = 255 - r;
    g = 255 - g;
    b = 255 - b;
    return ((b | g << 8 | r << 16) / 0x1000000).toString(16).substring(2);
}

export function ipToColor(ip : string) {
    if (!ip.includes('.')) {
        return null
    }

    let parts : any[] = ip.split('.');
    parts = parts.map((val) => parseInt(val) / 255);
    parts = parts.map(val => Math.round(255 * (1 - val) * (1 - parts[3])));

    parts = parts.map(function(dec) {
        var zerobefore = "";
        if (dec < 16)
            zerobefore = "0";
        return zerobefore + dec.toString(16);

    });
    return "#" + parts[0] + parts[1] + parts[2];
}